import { t } from 'i18next';
import { FC } from 'react';
import { mapToShortDate } from '../../../../utils/time';
import { CloseIconButton } from '../../../common/Buttons';
import { Row } from '../../../common/LayoutComponents';

const testIds = {
  heading: 'TimetableVersionPanelHeading::heading',
  closeButton: 'TimetableVersionPanelHeading::closeButton',
};

type TimetableVersionPanelHeadingProps = {
  readonly onClose: () => void;
  readonly validityStart: Temporal.PlainDate | null;
  readonly validityEnd: Temporal.PlainDate | null;
};

export const TimetableVersionPanelHeading: FC<
  TimetableVersionPanelHeadingProps
> = ({ validityStart, validityEnd, onClose }) => (
  <Row className="mb-4 ml-2 justify-between">
    <h2 data-testid={testIds.heading}>
      <span className="block text-sm">
        {t(($) => $.timetables.scheduleValid)}
      </span>
      <span className="text-2xl">{`${mapToShortDate(
        validityStart,
      )} - ${mapToShortDate(validityEnd)}`}</span>
    </h2>
    <CloseIconButton
      label={t(($) => $.close)}
      className="text-base font-bold text-brand"
      onClick={onClose}
      testId={testIds.closeButton}
    />
  </Row>
);
